/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext } from 'react';
import { globalContext } from 'context/global';

export default function useGlobal() {
  const global = useContext(globalContext);
  return global;
}
